module.exports = RES_SOUND;